import { EMPTY_LIST } from '../../../../../constants/common'
import { normalizeEmail } from '../../../Email.utils'
import { EMAIL_CREATION_FORM_FIELD_NAME_TO } from '../../EmailCreationForm.constants'
import { isPrinterRoutedRecipient } from '../../EmailCreationForm.utils'

// Number of unique recipients that will actually receive a mass email:
// excludes blacklisted addresses and deduplicates by normalized email.
// Printer-routed recipients (those without a direct email) are counted once via the printer's email.
export function getMassEmailEffectiveRecipientCount({
  blackList = EMPTY_LIST,
  printer,
  values,
}) {
  const to = values?.[EMAIL_CREATION_FORM_FIELD_NAME_TO] || EMPTY_LIST
  const blackSet = new Set(blackList.map(normalizeEmail))

  const uniqueEmails = to
    .filter(item => item?.value)
    .reduce((acc, item) => {
      const email = isPrinterRoutedRecipient(item, printer)
        ? normalizeEmail(printer?.email)
        : normalizeEmail(item?.email)

      if (email && !blackSet.has(email)) {
        acc.add(email)
      }

      return acc
    }, new Set())

  return uniqueEmails.size
}
